import React from 'react';
import '../styles/Training.css';

const Training = () => {
  const trainingItems = [
    {
      icon: 'fas fa-mobile-alt',
      title: 'Mobile App',
      description: 'Enroll in our mobile app development training to kick start your career as a mobile app developer.'
    },
    {
      icon: 'fas fa-shopping-cart',
      title: 'Digital Marketing',
      description: 'Want to start a career as a digital marketer, or grow your career in digital marketing, enroll!'
    },
    {
      icon: 'fas fa-paint-brush',
      title: 'Graphics',
      description: 'Become an expert graphics designer by enrolling in our graphics design classes.'
    }
  ];

  return (
    <div className="training-area section-padding" id="more-feature">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h2 className="section-title">Our Training Programs</h2>
            <div className="sub-heading">
              <p className="section-subtitle">
                Check out a list of some of our training packages tailored to give you a 
                head start in your digital career.
              </p>
            </div>
          </div>
        </div>

        <div className="row align-items-start">
          {/* Left Side - Image (70%) */}
          <div className="col-lg-7 col-md-12">
            <div className="training-image-container">
              <img 
                className="training-img" 
                src="https://metroblue.com.ng/assets/website/img/training.png" 
                alt="Training" 
              />
            </div>
          </div>

          {/* Right Side - Training Items (30%) */}
          <div className="col-lg-5 col-md-12">
            <div className="training-list">
              {trainingItems.map((item, index) => (
                <div key={index} className="training-item">
                  <div className="training-icon">
                    <i className={item.icon}></i>
                  </div>
                  <div className="training-details">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Web Development Training - Aligned with image (70%) */}
        <div className="row">
          <div className="col-lg-7 col-md-12">
            <div className="web-development-card">
              <h3>Web Development Training</h3>
              <p>
                Our web development training covers a wide range of languages that can help you
                build a career as a web developer. You can choose to become a UI/UX designer, a 
                frontend developer, backend developer or even a full-stack web developer as the case 
                may be.
              </p>
              <p>
                Our web development courses include HTML, CSS, Tailwind, Javascript(Jquery, ReactJS, AngularJS), TypeScript, Python (and Django),
                PHP (and Laravel), NodeJS (and ExpressJS), MongoDB, Postgres, MySQL...
              </p>
              <a href="https://metroblue.com.ng/traininginfo" className="training-btn">
                Continue reading...
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Training;